import { makeStyles } from '@material-ui/core'

export const useExpandingRadioCardStyles = makeStyles(() => ({
  group: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--vel-fixed-spacing-05)',
  },
  card: {
    '& label': {
      width: '100%',
    },
  },
  expanded: {
    borderRadius: 'var(--vel-shape300-border_radius)',
    border: '1px solid var(--vel-color-neutral-300)',
    background: 'var(--vel-color-neutral-white)',
    '& label': {
      border: '0 !important',
      background: 'transparent !important',
      boxShadow: 'none !important',
    },
    '& label::before': {
      boxShadow: 'none !important',
    },
    '&:has(label:hover)': {
      borderColor: 'var(--vel-color-neutral-600)',
    },
    '&:has(label input:focus)': {
      boxShadow:
        '0 0 0 2px var(--vel-color-misc-focused) inset, 0 0 0 2px var(--vel-color-neutral-white)',
    },
  },
  content: {
    margin: '0 var(--vel-fixed-spacing-05)',
    padding: 'var(--vel-fixed-spacing-05) 0',
    borderTop: '1px solid var(--vel-color-neutral-300)',
  },
}))
